<!-- eslint-disable max-len -->
<template>
  <div>
    <Card
      title="In-App Management"
    >
      <template v-slot:button>
        <Button @clicked="toggleModalCreateIap()" label="Add In-App Purchase" variant="primary"/>
      </template>
      <template v-slot:body>
        <div class="pb-6 flex justify-between items-center">
          <div class="flex items-center">
            <div class="mr-2">
              <el-input placeholder="search" v-model="filter" @change="searchNameInAppPurchase" ></el-input>
            </div>
            <Button @clicked="searchNameInAppPurchase" label="Apply"/>
            <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetInAppPurchaseView" /></button>
          </div>
        </div>
        <data-tables-server ref="tableSong" class="song-management" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [6] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom" >
          </el-table-column>
          <el-table-column v-if="!isFinance" label="Actions" align="right" width="180px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Edit" :position="'is-left'">
                  <button  @click="edit($event, scope.row)" class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="!isOps" label="Delete" :position="'is-left'">
                  <button @click="remove($event, scope.row)" class="p-2 w-8 mr-2 rounded bg-red-500 hover:bg-red-6000 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      ref="addSongDetail"
      :isShowingModal="isShowingModalCreateIap"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Submit IAP Detail"
      title="Add In App Purchase Detail"
      @toggleModal="toggleModalCreateIap()"
      @save="submitIap()" >
      <template slot="body" >
        <form class="flex w-full overflow-y-auto overflow-x-hidden" id="form-activity" autocomplete="off" >
          <div class="w-full p-2" >
            <form-item label='Platform'>
              <el-select v-model="input.platform" filterable placeholder="Select Platform" class="w-full">
                <el-option value="android" >Android</el-option>
                <el-option value="ios" >iOS</el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.input.platform.$dirty">
                <text-error v-if="!$v.input.platform.required" text="Please fill Platform." />
              </div>
            </form-item>
            <form-item label='Name'>
              <Input
                v-model="input.name"
                placeholder="IAP Name"
                :error="$v.input.name.$dirty && (!$v.input.name.required || !$v.input.name.maxLength)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.input.name.$dirty">
                <text-error v-if="!$v.input.name.required" text="Please fill name IAP." />
                <text-error v-if="!$v.input.name.maxLength" text="Max length name IAP is 100 character." />
              </div>
            </form-item>
            <form-item label='Identifier'>
              <Input
                v-model="input.identifier"
                placeholder="Identifier IAP"
                :error="$v.input.identifier.$dirty && (!$v.input.identifier.required || !$v.input.identifier.maxLength)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.input.identifier.$dirty">
                <text-error v-if="!$v.input.identifier.required" text="Please fill Identifier IAP." />
                <text-error v-if="!$v.input.identifier.maxLength" text="Max length Identifier IAP is 100 character." />
              </div>
            </form-item>
            <form-item label='Price in Dollar'>
              <Input
                v-model="input.price_dollar"
                placeholder="Price in Dollar"
                :error="$v.input.price_dollar.$dirty && (!$v.input.price_dollar.required || !$v.input.price_dollar.decimal)"
              />
              <div class="flex flex-col pt-2" v-if="$v.input.price_dollar.$dirty">
                <text-error v-if="!$v.input.price_dollar.required" text="Please fill Price." />
                <text-error v-if="!$v.input.price_dollar.decimal" text="Please fill Price with decimal." />
              </div>
            </form-item>
            <form-item label='Price in Credit'>
              <Input
                v-model="input.price_credit"
                placeholder="Price in Credit"
                :error="$v.input.price_credit.$dirty && (!$v.input.price_credit.required || !$v.input.price_credit.numeric)"
              />
              <div class="flex flex-col pt-2" v-if="$v.input.price_credit.$dirty">
                <text-error v-if="!$v.input.price_credit.required" text="Please fill Credit." />
                <text-error v-if="!$v.input.price_credit.numeric" text="Please fill Credit with number." />
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, decimal, numeric, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import ModalDialog from '@/components/Common/ModalDialog';
import ModalDialogDetail from '@/components/Common/ModalDialogDetail';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import Card from '@/components/Layout/Card.vue';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';

export default {
  name: 'IapManagement',
  mixins: [validationMixin],
  data: () => ({
    filter: '',
    isShowingModalCreateIap: false,
    isError: false,
    isUpdate: false,
    input: {
      platform: '',
      name: '',
      identifier: '',
      price_dollar: '',
      price_credit: '',
    },
    titles: [
      {
        prop: 'platform',
        label: 'Platform',
      },
      {
        prop: 'name',
        label: 'Name',
      },
      {
        prop: 'identifier',
        label: 'Identifier',
      },
      {
        prop: 'price_dollar',
        label: 'Dollar',
      },
      {
        prop: 'price_credit',
        label: 'Credit',
      },
    ],
    data: [],
    total: 0,
  }),
  validations: {
    input: {
      platform: {
        required,
        maxLength: maxLength(100),
      },
      name: {
        required,
        maxLength: maxLength(100),
      },
      identifier: {
        required,
        maxLength: maxLength(100),
      },
      price_dollar: {
        required,
        decimal,
      },
      price_credit: {
        required,
        numeric,
      },
    },
  },
  computed: {
    ...mapGetters('IAPModule', ['listIap']),
    ...mapGetters('NotificationModule', ['isLoading']),
    ...mapGetters('AuthModule', ['isAdmin', 'isSuperAdmin', 'isOps', 'isFinance']),

  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListIap();
  },
  watch: {
    listIap: {
      immediate: true,
      deep: true,
      handler(val) {
        this.data = val.data;
        this.total = val.total;
      },
    },
  },
  methods: {
    ...mapActions('IAPModule', ['requestListIap', 'requestAddIap', 'requestUpdateIap', 'requestRemoveIap']),
    resetState() {
      this.input = Object.assign({}, {
        platform: '',
        name: '',
        identifier: '',
        price_dollar: '',
        price_credit: '',
      });
    },
    toggleAction(event) {
      let popupaction = event.srcElement.closest('.container-action').children[1];
      if (popupaction == null) {
        popupaction = event.srcElement.closest('.container-action').children[0];
      }
      popupaction.classList.toggle('hidden');
    },
    toggleModalCreateIap() {
      this.isShowingModalCreateIap = !this.isShowingModalCreateIap;
      this.resetState();
    },
    async submitIap() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const iap = Object.assign({}, this.input);
          if (!this.isUpdate) {
            await this.requestAddIap(iap);
          } else {
            await this.requestUpdateIap(iap);
          }
          this.toggleModalCreateIap();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        this.isError = true;
      }
    },
    edit(event, row) {
      this.toggleAction(event);
      this.isUpdate = true;
      this.input = Object.assign({}, row);
      this.isShowingModalCreateIap = !this.isShowingModalCreateIap;
    },
    async remove(event, row) {
      this.toggleAction(event);
      try {
        await this.requestRemoveIap({ id: row.id });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        this.isError = true;
      }
    },
    searchNameInAppPurchase() {

    },
    resetInAppPurchaseView() {

    },
    onChangeTable() {

    },
  },
  components: {
    ModalDialog,
    ModalDialogDetail,
    VueCustomTooltip,
    Card,
    Button,
    FormItem, Input, TextArea, TextError, Select
  },
};
</script>



// WEBPACK FOOTER //
// src/views/IapManagement.vue